var navmanager = {

    init: function () {
        //this.footerSubMenus();
        this.closeSubMenu();
        this.mobileSubMenuToggle();
        this.scrollObserver();
        this.mobileToggle();
        //this.preventDefaultForNonLinks();
    },
    scrollObserver: function () {
        let lastScroll = 0;
        const bufferZone = 50;
        let isScrolling;

        const header = document.getElementById('header');
        //const headermob = document.querySelector('.header-mobile');
        const toggleClassOnScroll = () => {
            const currentScroll = window.scrollY;
            if (Math.abs(lastScroll - currentScroll) >= bufferZone) {
                if (currentScroll > lastScroll) {
                    header.classList.add('scrolled');
                    //headermob.classList.add('scrolled');
                } else {
                    header.classList.remove('scrolled');
                    //headermob.classList.remove('scrolled');
                }
                lastScroll = currentScroll;
            }
            window.clearTimeout(isScrolling);
            isScrolling = setTimeout(function() {
                lastScroll = currentScroll;
            }, 66);
        };

        const raf = requestAnimationFrame || mozRequestAnimationFrame || webkitRequestAnimationFrame || msRequestAnimationFrame;

        const efficientScrollHandler = () => {
            raf(toggleClassOnScroll);
        };

        window.addEventListener('scroll', efficientScrollHandler);
    },

    mobileToggle: function () {
        var toggle = document.getElementById('menu-toggle');
        var menu = document.getElementById('mobile-dropdown');
        if (toggle != undefined) {
            toggle.addEventListener('click', function (e) {
                toggle.classList.toggle('open');
                menu.classList.toggle('hidden');
                //document.body.classList.toggle('modal-open');
            });
        }
    },

    mobileSubMenuToggle: function () {
        var hassubmenu = document.querySelectorAll("#mobile-dropdown .menu-item-has-children > a ");
        for (var i = 0; i < hassubmenu.length; i++) {
            hassubmenu[i].onclick = function (e) {
                e.preventDefault();

                var el = e.target;
                var showmenu = el.nextElementSibling;
                if (showmenu) {
                    //el.classList.toggle('open');
                    el.classList.toggle('open');
                }
            };
        }
    },

    closeSubMenu: function () {
        //submenu-actions__back
        var backbuttons = document.querySelectorAll('.submenu-back');
        backbuttons.forEach(el => el.addEventListener('click', event => {
            var el = event.target;
            var elparent = el.closest('.sub-menu');
            elparent.previousElementSibling.classList.remove('open');
        }));
    },

    //Footer Sub menus
    footerSubMenus: function () {
        const footersubmenus = document.querySelectorAll('.footer__menu-title');
        footersubmenus.forEach(el => el.addEventListener('click', event => {
            event.preventDefault();
            event.target.classList.toggle('open');
            event.target.nextElementSibling.classList.toggle('open');
        }));
    },
}

export default navmanager;
